module.exports = __webpack_public_path__ + "img/campus-live-akquise.2033e3a9.svg";